const Logo = (props) => (
  <img style={{ width: '100%'}}
    alt="Logo"
    src="/static/logo.png"
    {...props}
  />
);

export default Logo;
